
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import {label} from './Dictionary.js';

function DisplayURLDialog({open, handleSubmit, handleClose, OKButtonTitle}) {

    return (
        <>
        <Dialog
            open={open}
            fullScreen
            onClose={handleClose}
            PaperProps={{
            component: 'form',
            onSubmit: (event) => {
                event.preventDefault();
                const formData = new FormData(event.currentTarget);
                const formJson = Object.fromEntries(formData.entries());
                const email = formJson.email;
                //console.log(email);

                handleSubmit(email);
                handleClose();
            },
            }}
        >
            <DialogTitle>{label("ID_DisplayURL")}</DialogTitle>
            <DialogContent>
                
            {handleSubmit ? (
            <TextField
                autoFocus
                required
                margin="dense"
                id="name"
                name="email"
                label={label("ID_EnterTheURL")}
                type="text"
                fullWidth
                variant="standard"
            />
            ) : (
                <></>
            )}

            </DialogContent>
            <DialogActions sx={{ position: 'fixed', backgroundColor:`white`, height:120, bottom: 0, left: 0, right: 0 }}>
            {handleSubmit && handleClose ? (
                <>
                <Button variant="contained" onClick={handleClose}>{label("ID_Cancel")}</Button>
                <Button variant="contained" type="submit">{OKButtonTitle}</Button>
                </>
            ) : (
                <></>
            )}

            </DialogActions>
        </Dialog>
        </>
    );

}

export default DisplayURLDialog;